/* eslint-disable */

import request from '@/utils/request'

export function getNotiList(params) {
  return request({
    url: '/config-service/v1/user-group-notification',
    method: 'get',
    params: params
  })
}

export function putSeenNotiList(data) {
  return request({
    url: '/config-service/v1/user-group-notification',
    method: 'put',
    data: data
  })
}
